export default class FileUtils {

    /**
     * Convert a base64 PDF string to a Blob URL and open it in a new tab.
     * @param base64Pdf The base64 encoded PDF string.
     * @returns A Blob URL for the PDF.
     */
    static base64ToBlobUrl = (base64Pdf: string) =>{
        // Decode base64 string to binary
        const byteCharacters = atob(base64Pdf);
        const byteNumbers = new Array(byteCharacters.length).fill(0).map((_, i) => byteCharacters.charCodeAt(i));
        const byteArray = new Uint8Array(byteNumbers);

        // Create a Blob from the byte array
        const blob = new Blob([byteArray], { type: 'application/pdf' });

        // Create a Blob URL and open it
        const blobUrl = URL.createObjectURL(blob);
        return blobUrl;
    }
}